import * as React from 'react'
import { ExpandMoreIcon } from '@toasttab/buffet-pui-icons'
export interface CollapsibleListProps {
  /** Determines whether list will be collapsed on the initial render. */
  defaultCollapsed: boolean
  /** ReactNodes to render inside of the list. Each will be wrapped in <li> tag. */
  children: React.ReactNode[]
  /** Text to render as a list header. */
  header: string
  /** Callback to run when user clicks list */
  handleOnClick?: (event: React.SyntheticEvent) => void
}

export const CollapsibleList = ({
  header,
  children,
  defaultCollapsed,
  handleOnClick
}: CollapsibleListProps) => {
  const [collapsed, setCollapsed] = React.useState(defaultCollapsed)
  const expanded = !collapsed

  return (
    <div className='border-t-0 border-b border-l-0 border-r-0 border-solid border-black-12'>
      <button
        className='w-full px-2 py-3 bg-transparent border-0'
        type='button'
        onClick={(event) => {
          if (handleOnClick) {
            handleOnClick(event)
          }
          setCollapsed(!collapsed)
        }}
      >
        <div className={'flex justify-between items-center text-oo-black-87'}>
          <h3 className='my-0 text-left text-oo-black-87'>{header}</h3>
          <ExpandMoreIcon
            title='toggle-list'
            className={
              expanded ? 'transform rotate-180 fill-current' : 'fill-current'
            }
          />
        </div>
      </button>
      <ul className={`pb-3 px-1 my-0 ${expanded ? '' : 'hidden'}`}>
        {children.map((child, idx) => (
          <li key={idx} className='px-1'>
            {child}
          </li>
        ))}
      </ul>
    </div>
  )
}
